import React from 'react'
import { getQuestionOptionIndex } from '../../utils'
import { QuestionChoice } from '@mission.io/question-toolkit'

import 'styled-components/macro'
import { styled } from 'styled-components'
import OptionalMarkdown from '../Markdown/OptionalMarkdown'
import { _tempTheme } from '../../utils/tempTheme'

interface DropdownProps {
	choices: QuestionChoice[]
	index: number
}
//Component that render a  Dropdown card
export default function ChoicesReadOnly(props: DropdownProps): JSX.Element {
	const { choices, index } = props
	return (
		<DropdownWrapper role="section" className="w-[calc(50%-theme(spacing.1))]">
			<div className="content">
				<div className="header-card notranslate">{`Q${index + 1}:`}</div>
				<ul>
					{choices.map((choice: QuestionChoice, idx: number) => {
						const classNameCorrect = choice.answer ? 'answer-correct' : ''
						return (
							<Option key={String(choice._id)}>
								<InlineDiv className={`index ${classNameCorrect} notranslate`}>
									{`${getQuestionOptionIndex(idx)}.`}&nbsp;
								</InlineDiv>
								<InlineDiv className={`answer ${classNameCorrect}`}>
									<OptionalMarkdown>{choice.text}</OptionalMarkdown>
								</InlineDiv>
								<InlineDiv className={`answer ${classNameCorrect}`}>
									&nbsp;{`${classNameCorrect ? '- (Correct) ' : ''}`}
								</InlineDiv>
							</Option>
						)
					})}
				</ul>
			</div>
		</DropdownWrapper>
	)
}

const InlineDiv = styled.div`
	display: inline-block;
`

const DropdownWrapper = styled.div`
	text-align: left;
	box-sizing: border-box;

	.content {
		padding: 1rem;
		border: 1px solid ${({ theme }) => theme.boxShadow};
		box-sizing: border-box;
		height: 100%;
	}

	.header-card {
		font-family: ${({ theme }) => theme.fontFamily};
		font-style: normal;
		font-weight: ${_tempTheme.font_semibold};
		font-size: ${_tempTheme.text_sm};
		line-height: ${_tempTheme.text_base};
	}
	ul,
	li {
		margin: 0;
		padding: ${_tempTheme.spacing1} 0;
	}
`

export const Option = styled.li`
	display: block;
	font-family: ${({ theme }) => theme.fontFamily};
	.index {
		font-style: normal;
		font-weight: ${_tempTheme.font_semibold};
		font-size: ${_tempTheme.text_sm};
		line-height: ${_tempTheme.text_base};
		color: ${({ theme }) => theme.onBase};
	}
	.answer-correct {
		color: ${({ theme }) => theme.success} !important;
	}
	.answer {
		font-style: normal;
		font-weight: normal;
		font-size: ${_tempTheme.text_sm};
		line-height: ${_tempTheme.text_sm};
		color: ${({ theme }) => theme.onBase};
	}
`
